import { useAuth } from "@/context/AuthContext";
import ManagerDashboard from "@/pages/dashboards/ManagerDashboard";
import OpsDashboard from "@/pages/dashboards/OpsDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (user.role === "manager") return <ManagerDashboard />;
  return <OpsDashboard />;
}
